export default "__VITE_ASSET__A_Ij3R_v__"